(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// noinspection DuplicatedCode


var $955a30e48c5aca63$exports = {};
/* @preserve
    _____ __ _     __                _
   / ___// /(_)___/ /___  ____      (_)___
  / (_ // // // _  // -_)/ __/_    / /(_-<
  \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                              |___/

  Version: 1.7.4
  Author: Nick Piscitelli (pickykneee)
  Website: https://nickpiscitelli.com
  Documentation: http://nickpiscitelli.github.io/Glider.js
  License: MIT License
  Release Date: October 25th, 2018

*/ /* global define */ (function(factory) {
    typeof define === 'function' && define.amd ? define(factory) : $955a30e48c5aca63$exports = factory();
})(function() {
    'use strict' // eslint-disable-line no-unused-expressions
    ;
    /* globals window:true */ var _window = typeof window !== 'undefined' ? window : this;
    var Glider = _window.Glider = function(element, settings) {
        var _ = this;
        if (element._glider) return element._glider;
        _.ele = element;
        _.ele.classList.add('glider');
        // expose glider object to its DOM element
        _.ele._glider = _;
        // merge user setting with defaults
        _.opt = Object.assign({}, {
            slidesToScroll: 1,
            slidesToShow: 1,
            resizeLock: true,
            duration: 0.5,
            passiveListeners: false,
            // easeInQuad
            easing: function(x, t, b, c, d) {
                return c * (t /= d) * t + b;
            }
        }, settings);
        // set defaults
        _.animate_id = _.page = _.slide = 0;
        _.arrows = {};
        // preserve original options to
        // extend breakpoint settings
        _._opt = _.opt;
        if (_.opt.skipTrack) // first and only child is the track
        _.track = _.ele.children[0];
        else {
            // create track and wrap slides
            _.track = document.createElement('div');
            _.ele.appendChild(_.track);
            while(_.ele.children.length !== 1)_.track.appendChild(_.ele.children[0]);
        }
        _.track.classList.add('glider-track');
        // start glider
        _.init();
        // set events
        _.resize = _.init.bind(_, true);
        _.event(_.ele, 'add', {
            scroll: _.updateControls.bind(_)
        }, {
            passive: _.opt.passiveListeners
        });
        _.event(_window, 'add', {
            resize: _.resize
        });
    };
    var gliderPrototype = Glider.prototype;
    gliderPrototype.init = function(refresh, paging) {
        var _ = this;
        var width = 0;
        var height = 0;
        _.slides = _.track.children;
        [].forEach.call(_.slides, function(_, i) {
            _.classList.add('glider-slide');
            _.setAttribute('data-gslide', i);
        });
        _.containerWidth = _.ele.clientWidth;
        var breakpointChanged = _.settingsBreakpoint();
        if (!paging) paging = breakpointChanged;
        if (_.opt.slidesToShow === 'auto' || typeof _.opt._autoSlide !== 'undefined') {
            var slideCount = _.containerWidth / _.opt.itemWidth;
            _.opt._autoSlide = _.opt.slidesToShow = _.opt.exactWidth ? slideCount : Math.max(1, Math.floor(slideCount));
        }
        if (_.opt.slidesToScroll === 'auto') _.opt.slidesToScroll = Math.floor(_.opt.slidesToShow);
        _.itemWidth = _.opt.exactWidth ? _.opt.itemWidth : _.containerWidth / _.opt.slidesToShow;
        // set slide dimensions
        [].forEach.call(_.slides, function(__) {
            __.style.height = 'auto';
            __.style.width = _.itemWidth + 'px';
            width += _.itemWidth;
            height = Math.max(__.offsetHeight, height);
        });
        _.track.style.width = width + 'px';
        _.trackWidth = width;
        _.isDrag = false;
        _.preventClick = false;
        _.move = false;
        _.opt.resizeLock && _.scrollTo(_.slide * _.itemWidth, 0);
        if (breakpointChanged || paging) {
            _.bindArrows();
            _.buildDots();
            _.bindDrag();
        }
        _.updateControls();
        _.emit(refresh ? 'refresh' : 'loaded');
    };
    gliderPrototype.bindDrag = function() {
        var _ = this;
        _.mouse = _.mouse || _.handleMouse.bind(_);
        var mouseup = function() {
            _.mouseDown = undefined;
            _.ele.classList.remove('drag');
            if (_.isDrag) _.preventClick = true;
            _.isDrag = false;
        };
        const move = function() {
            _.move = true;
        };
        var events = {
            mouseup: mouseup,
            mouseleave: mouseup,
            mousedown: function(e) {
                e.preventDefault();
                e.stopPropagation();
                _.mouseDown = e.clientX;
                _.ele.classList.add('drag');
                _.move = false;
                setTimeout(move, 300);
            },
            touchstart: function(e) {
                _.ele.classList.add('drag');
                _.move = false;
                setTimeout(move, 300);
            },
            mousemove: _.mouse,
            click: function(e) {
                if (_.preventClick && _.move) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                _.preventClick = false;
                _.move = false;
            }
        };
        _.ele.classList.toggle('draggable', _.opt.draggable === true);
        _.event(_.ele, 'remove', events);
        if (_.opt.draggable) _.event(_.ele, 'add', events, {
            passive: _.opt.passiveListeners
        });
    };
    gliderPrototype.buildDots = function() {
        var _ = this;
        if (!_.opt.dots) {
            if (_.dots) _.dots.innerHTML = '';
            return;
        }
        if (typeof _.opt.dots === 'string') _.dots = document.querySelector(_.opt.dots);
        else _.dots = _.opt.dots;
        if (!_.dots) return;
        _.dots.innerHTML = '';
        _.dots.setAttribute('role', 'tablist');
        _.dots.classList.add('glider-dots');
        for(var i = 0; i < Math.ceil(_.slides.length / _.opt.slidesToShow); ++i){
            var dot = document.createElement('button');
            dot.dataset.index = i;
            dot.setAttribute('aria-label', 'Page ' + (i + 1));
            dot.setAttribute('role', 'tab');
            dot.className = 'glider-dot ' + (i ? '' : 'active');
            _.event(dot, 'add', {
                click: _.scrollItem.bind(_, i, true)
            });
            _.dots.appendChild(dot);
        }
    };
    gliderPrototype.bindArrows = function() {
        var _ = this;
        if (!_.opt.arrows) {
            Object.keys(_.arrows).forEach(function(direction) {
                var element = _.arrows[direction];
                _.event(element, 'remove', {
                    click: element._func
                });
            });
            return;
        }
        [
            'prev',
            'next'
        ].forEach(function(direction) {
            var arrow = _.opt.arrows[direction];
            if (arrow) {
                if (typeof arrow === 'string') arrow = document.querySelector(arrow);
                if (arrow) {
                    arrow._func = arrow._func || _.scrollItem.bind(_, direction);
                    _.event(arrow, 'remove', {
                        click: arrow._func
                    });
                    _.event(arrow, 'add', {
                        click: arrow._func
                    });
                    _.arrows[direction] = arrow;
                }
            }
        });
    };
    gliderPrototype.updateControls = function(event) {
        var _ = this;
        if (event && !_.opt.scrollPropagate) event.stopPropagation();
        var disableArrows = _.containerWidth >= _.trackWidth;
        if (!_.opt.rewind) {
            if (_.arrows.prev) {
                _.arrows.prev.classList.toggle('disabled', _.ele.scrollLeft <= 0 || disableArrows);
                _.arrows.prev.setAttribute('aria-disabled', _.arrows.prev.classList.contains('disabled'));
            }
            if (_.arrows.next) {
                _.arrows.next.classList.toggle('disabled', Math.ceil(_.ele.scrollLeft + _.containerWidth) >= Math.floor(_.trackWidth) || disableArrows);
                _.arrows.next.setAttribute('aria-disabled', _.arrows.next.classList.contains('disabled'));
            }
        }
        _.slide = Math.round(_.ele.scrollLeft / _.itemWidth);
        _.page = Math.round(_.ele.scrollLeft / _.containerWidth);
        var middle = _.slide + Math.floor(Math.floor(_.opt.slidesToShow) / 2);
        var extraMiddle = Math.floor(_.opt.slidesToShow) % 2 ? 0 : middle + 1;
        if (Math.floor(_.opt.slidesToShow) === 1) extraMiddle = 0;
        // the last page may be less than one half of a normal page width so
        // the page is rounded down. when at the end, force the page to turn
        if (_.ele.scrollLeft + _.containerWidth >= Math.floor(_.trackWidth)) _.page = _.dots ? _.dots.children.length - 1 : 0;
        [].forEach.call(_.slides, function(slide, index) {
            var slideClasses = slide.classList;
            var wasVisible = slideClasses.contains('visible');
            var start = _.ele.scrollLeft;
            var end = _.ele.scrollLeft + _.containerWidth;
            var itemStart = _.itemWidth * index;
            var itemEnd = itemStart + _.itemWidth;
            [].forEach.call(slideClasses, function(className) {
                /^left|right/.test(className) && slideClasses.remove(className);
            });
            slideClasses.toggle('active', _.slide === index);
            if (middle === index || extraMiddle && extraMiddle === index) slideClasses.add('center');
            else {
                slideClasses.remove('center');
                slideClasses.add([
                    index < middle ? 'left' : 'right',
                    Math.abs(index - (index < middle ? middle : extraMiddle || middle))
                ].join('-'));
            }
            var isVisible = Math.ceil(itemStart) >= Math.floor(start) && Math.floor(itemEnd) <= Math.ceil(end);
            slideClasses.toggle('visible', isVisible);
            if (isVisible !== wasVisible) _.emit('slide-' + (isVisible ? 'visible' : 'hidden'), {
                slide: index
            });
        });
        if (_.dots) [].forEach.call(_.dots.children, function(dot, index) {
            dot.classList.toggle('active', _.page === index);
        });
        if (event && _.opt.scrollLock) {
            clearTimeout(_.scrollLock);
            _.scrollLock = setTimeout(function() {
                clearTimeout(_.scrollLock);
                // dont attempt to scroll less than a pixel fraction - causes looping
                if (Math.abs(_.ele.scrollLeft / _.itemWidth - _.slide) > 0.02) {
                    if (!_.mouseDown) // Only scroll if not at the end (#94)
                    {
                        if (_.trackWidth > _.containerWidth + _.ele.scrollLeft) _.scrollItem(_.getCurrentSlide());
                    }
                }
            }, _.opt.scrollLockDelay || 250);
        }
    };
    gliderPrototype.getCurrentSlide = function() {
        var _ = this;
        return _.round(_.ele.scrollLeft / _.itemWidth);
    };
    gliderPrototype.scrollItem = function(slide, dot, e) {
        if (e) e.preventDefault();
        var _ = this;
        var originalSlide = slide;
        ++_.animate_id;
        var prevSlide = _.slide;
        var position;
        if (dot === true) {
            slide = Math.round(slide * _.containerWidth / _.itemWidth);
            position = slide * _.itemWidth;
        } else {
            if (typeof slide === 'string') {
                var backwards = slide === 'prev';
                // use precise location if fractional slides are on
                if (_.opt.slidesToScroll % 1 || _.opt.slidesToShow % 1) slide = _.getCurrentSlide();
                else slide = _.slide;
                if (backwards) slide -= _.opt.slidesToScroll;
                else slide += _.opt.slidesToScroll;
                if (_.opt.rewind) {
                    var scrollLeft = _.ele.scrollLeft;
                    slide = backwards && !scrollLeft ? _.slides.length : !backwards && scrollLeft + _.containerWidth >= Math.floor(_.trackWidth) ? 0 : slide;
                }
            }
            slide = Math.max(Math.min(slide, _.slides.length), 0);
            _.slide = slide;
            position = _.itemWidth * slide;
        }
        _.emit('scroll-item', {
            prevSlide: prevSlide,
            slide: slide
        });
        _.scrollTo(position, _.opt.duration * Math.abs(_.ele.scrollLeft - position), function() {
            _.updateControls();
            _.emit('animated', {
                value: originalSlide,
                type: typeof originalSlide === 'string' ? 'arrow' : dot ? 'dot' : 'slide'
            });
        });
        return false;
    };
    gliderPrototype.settingsBreakpoint = function() {
        var _ = this;
        var resp = _._opt.responsive;
        if (resp) {
            // Sort the breakpoints in mobile first order
            resp.sort(function(a, b) {
                return b.breakpoint - a.breakpoint;
            });
            for(var i = 0; i < resp.length; ++i){
                var size = resp[i];
                if (_window.innerWidth >= size.breakpoint) {
                    if (_.breakpoint !== size.breakpoint) {
                        _.opt = Object.assign({}, _._opt, size.settings);
                        _.breakpoint = size.breakpoint;
                        return true;
                    }
                    return false;
                }
            }
        }
        // set back to defaults in case they were overriden
        var breakpointChanged = _.breakpoint !== 0;
        _.opt = Object.assign({}, _._opt);
        _.breakpoint = 0;
        return breakpointChanged;
    };
    gliderPrototype.scrollTo = function(scrollTarget, scrollDuration, callback) {
        var _ = this;
        var start = new Date().getTime();
        var animateIndex = _.animate_id;
        var animate = function() {
            var now = new Date().getTime() - start;
            _.ele.scrollLeft = _.ele.scrollLeft + (scrollTarget - _.ele.scrollLeft) * _.opt.easing(0, now, 0, 1, scrollDuration);
            if (now < scrollDuration && animateIndex === _.animate_id) _window.requestAnimationFrame(animate);
            else {
                _.ele.scrollLeft = scrollTarget;
                callback && callback.call(_);
            }
        };
        _window.requestAnimationFrame(animate);
    };
    gliderPrototype.removeItem = function(index) {
        var _ = this;
        if (_.slides.length) {
            _.track.removeChild(_.slides[index]);
            _.refresh(true);
            _.emit('remove');
        }
    };
    gliderPrototype.addItem = function(ele) {
        var _ = this;
        _.track.appendChild(ele);
        _.refresh(true);
        _.emit('add');
    };
    gliderPrototype.handleMouse = function(e) {
        var _ = this;
        if (_.mouseDown) {
            _.isDrag = true;
            _.ele.scrollLeft += (_.mouseDown - e.clientX) * (_.opt.dragVelocity || 3.3);
            _.mouseDown = e.clientX;
        }
    };
    // used to round to the nearest 0.XX fraction
    gliderPrototype.round = function(double) {
        var _ = this;
        var step = _.opt.slidesToScroll % 1 || 1;
        var inv = 1.0 / step;
        return Math.round(double * inv) / inv;
    };
    gliderPrototype.refresh = function(paging) {
        var _ = this;
        _.init(true, paging);
    };
    gliderPrototype.setOption = function(opt, global) {
        var _ = this;
        if (_.breakpoint && !global) _._opt.responsive.forEach(function(v) {
            if (v.breakpoint === _.breakpoint) v.settings = Object.assign({}, v.settings, opt);
        });
        else _._opt = Object.assign({}, _._opt, opt);
        _.breakpoint = 0;
        _.settingsBreakpoint();
    };
    gliderPrototype.destroy = function() {
        var _ = this;
        var replace = _.ele.cloneNode(true);
        var clear = function(ele) {
            ele.removeAttribute('style');
            [].forEach.call(ele.classList, function(className) {
                /^glider/.test(className) && ele.classList.remove(className);
            });
        };
        // remove track if it was created by glider
        if (!_.opt.skipTrack) replace.children[0].outerHTML = replace.children[0].innerHTML;
        clear(replace);
        [].forEach.call(replace.getElementsByTagName('*'), clear);
        _.ele.parentNode.replaceChild(replace, _.ele);
        _.event(_window, 'remove', {
            resize: _.resize
        });
        _.emit('destroy');
    };
    gliderPrototype.emit = function(name, arg) {
        var _ = this;
        var e = new _window.CustomEvent('glider-' + name, {
            bubbles: !_.opt.eventPropagate,
            detail: arg
        });
        _.ele.dispatchEvent(e);
    };
    gliderPrototype.event = function(ele, type, args) {
        var eventHandler = ele[type + 'EventListener'].bind(ele);
        Object.keys(args).forEach(function(k) {
            eventHandler(k, args[k]);
        });
    };
    return Glider;
});


function $cb75ffeff9590df4$var$e(e, t) {
    for(var o = 0; o < t.length; o++){
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function $cb75ffeff9590df4$var$t(e) {
    return function(e) {
        if (Array.isArray(e)) return $cb75ffeff9590df4$var$o(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return $cb75ffeff9590df4$var$o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cb75ffeff9590df4$var$o(e, t);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $cb75ffeff9590df4$var$o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
    return n;
}
var $cb75ffeff9590df4$var$n, $cb75ffeff9590df4$var$i, $cb75ffeff9590df4$var$a, $cb75ffeff9590df4$var$r, $cb75ffeff9590df4$var$s, $cb75ffeff9590df4$var$l = ($cb75ffeff9590df4$var$n = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
], $cb75ffeff9590df4$var$i = function() {
    function o(e) {
        var n = e.targetModal, i = e.triggers, a = void 0 === i ? [] : i, r = e.onShow, s = void 0 === r ? function() {} : r, l = e.onClose, c = void 0 === l ? function() {} : l, d = e.openTrigger, u = void 0 === d ? "data-micromodal-trigger" : d, f = e.closeTrigger, h = void 0 === f ? "data-micromodal-close" : f, v = e.openClass, g = void 0 === v ? "is-open" : v, m = e.disableScroll, b = void 0 !== m && m, y = e.disableFocus, p = void 0 !== y && y, w = e.awaitCloseAnimation, E = void 0 !== w && w, k = e.awaitOpenAnimation, M = void 0 !== k && k, A = e.debugMode, C = void 0 !== A && A;
        !function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, o), this.modal = document.getElementById(n), this.config = {
            debugMode: C,
            disableScroll: b,
            openTrigger: u,
            closeTrigger: h,
            openClass: g,
            onShow: s,
            onClose: c,
            awaitCloseAnimation: E,
            awaitOpenAnimation: M,
            disableFocus: p
        }, a.length > 0 && this.registerTriggers.apply(this, $cb75ffeff9590df4$var$t(a)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    var i, a, r;
    return i = o, a = [
        {
            key: "registerTriggers",
            value: function() {
                for(var e = this, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                o.filter(Boolean).forEach(function(t) {
                    t.addEventListener("click", function(t) {
                        return e.showModal(t);
                    });
                });
            }
        },
        {
            key: "showModal",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                    var o = function t() {
                        e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                    };
                    this.modal.addEventListener("animationend", o, !1);
                } else this.setFocusToFirstNode();
                this.config.onShow(this.modal, this.activeElement, t);
            }
        },
        {
            key: "closeModal",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = this.modal;
                if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                    var o = this.config.openClass;
                    this.modal.addEventListener("animationend", function e() {
                        t.classList.remove(o), t.removeEventListener("animationend", e, !1);
                    }, !1);
                } else t.classList.remove(this.config.openClass);
            }
        },
        {
            key: "closeModalById",
            value: function(e) {
                this.modal = document.getElementById(e), this.modal && this.closeModal();
            }
        },
        {
            key: "scrollBehaviour",
            value: function(e) {
                if (this.config.disableScroll) {
                    var t = document.querySelector("body");
                    switch(e){
                        case "enable":
                            Object.assign(t.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(t.style, {
                                overflow: "hidden"
                            });
                    }
                }
            }
        },
        {
            key: "addEventListeners",
            value: function() {
                this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "removeEventListeners",
            value: function() {
                this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "onClick",
            value: function(e) {
                (e.target.hasAttribute(this.config.closeTrigger) || e.target.parentNode.hasAttribute(this.config.closeTrigger)) && (e.preventDefault(), e.stopPropagation(), this.closeModal(e));
            }
        },
        {
            key: "onKeydown",
            value: function(e) {
                27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
            }
        },
        {
            key: "getFocusableNodes",
            value: function() {
                var e = this.modal.querySelectorAll($cb75ffeff9590df4$var$n);
                return Array.apply(void 0, $cb75ffeff9590df4$var$t(e));
            }
        },
        {
            key: "setFocusToFirstNode",
            value: function() {
                var e = this;
                if (!this.config.disableFocus) {
                    var t = this.getFocusableNodes();
                    if (0 !== t.length) {
                        var o = t.filter(function(t) {
                            return !t.hasAttribute(e.config.closeTrigger);
                        });
                        o.length > 0 && o[0].focus(), 0 === o.length && t[0].focus();
                    }
                }
            }
        },
        {
            key: "retainFocus",
            value: function(e) {
                var t = this.getFocusableNodes();
                if (0 !== t.length) {
                    if (t = t.filter(function(e) {
                        return null !== e.offsetParent;
                    }), this.modal.contains(document.activeElement)) {
                        var o = t.indexOf(document.activeElement);
                        e.shiftKey && 0 === o && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && o === t.length - 1 && (t[0].focus(), e.preventDefault());
                    } else t[0].focus();
                }
            }
        }
    ], $cb75ffeff9590df4$var$e(i.prototype, a), r && $cb75ffeff9590df4$var$e(i, r), o;
}(), $cb75ffeff9590df4$var$a = null, $cb75ffeff9590df4$var$r = function(e) {
    if (!document.getElementById(e)) return console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1;
}, $cb75ffeff9590df4$var$s = function(e, t) {
    if (function(e) {
        e.length <= 0 && (console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
    }(e), !t) return !0;
    for(var o in t)$cb75ffeff9590df4$var$r(o);
    return !0;
}, {
    init: function(e) {
        var o = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, e), n = $cb75ffeff9590df4$var$t(document.querySelectorAll("[".concat(o.openTrigger, "]"))), r = function(e, t) {
            var o = [];
            return e.forEach(function(e) {
                var n = e.attributes[t].value;
                void 0 === o[n] && (o[n] = []), o[n].push(e);
            }), o;
        }(n, o.openTrigger);
        if (!0 !== o.debugMode || !1 !== $cb75ffeff9590df4$var$s(n, r)) for(var l in r){
            var c = r[l];
            o.targetModal = l, o.triggers = $cb75ffeff9590df4$var$t(c), $cb75ffeff9590df4$var$a = new $cb75ffeff9590df4$var$i(o);
        }
    },
    show: function(e, t) {
        var o = t || {};
        o.targetModal = e, !0 === o.debugMode && !1 === $cb75ffeff9590df4$var$r(e) || ($cb75ffeff9590df4$var$a && $cb75ffeff9590df4$var$a.removeEventListeners(), ($cb75ffeff9590df4$var$a = new $cb75ffeff9590df4$var$i(o)).showModal());
    },
    close: function(e) {
        e ? $cb75ffeff9590df4$var$a.closeModalById(e) : $cb75ffeff9590df4$var$a.closeModal();
    }
});
"undefined" != typeof window && (window.MicroModal = $cb75ffeff9590df4$var$l);
var $cb75ffeff9590df4$export$2e2bcd8739ae039 = $cb75ffeff9590df4$var$l;


class $0f886f8e018ec522$export$2e2bcd8739ae039 {
    constructor(plugin){
        this.plugin = plugin;
        this.settings = plugin.settings;
    }
    product(product_id) {
        return waOrder.cart.$products.find(`[data-product-id="${product_id}"]`);
    }
    addProduct(product_id, sku_id) {
        return this.oldSSVersion(product_id, sku_id);
    }
    oldSSVersion(product_id, sku_id) {
        const href = this.settings.cart_url;
        const data = {
            'product_id': product_id,
            'quantity': 1
        };
        return $.post(href, data, 'json').then(()=>{
            waOrder.cart.reload();
        });
    }
    latestSSVersion(product_id, sku_id) {
        const href = this.settings.order_url + 'add';
        const data = {
            'item[product_id]': product_id,
            'item[sku_id]': sku_id,
            'item[quantity]': 1
        };
        return $.post(href, data, 'json').then(()=>{
            waOrder.cart.reload();
        });
    }
    deleteProduct(product_id) {
        const $product = this.product();
        const $quantity = $product.find('input.js-product-quantity');
        $quantity.val(0);
        this.getOption('cart').saveCart().then((api)=>{
            $product.remove();
            this.render();
        });
    }
}


shopAddsPlugin.api = new (0, $0f886f8e018ec522$export$2e2bcd8739ae039)(shopAddsPlugin);
shopAddsPlugin.Glider = (0, (/*@__PURE__*/$parcel$interopDefault($955a30e48c5aca63$exports)));
$(document).on('change', '[adds-switch]', function() {
    const product_id = this.getAttribute('adds-item-product-id');
    const sku_id = this.getAttribute('adds-item-sku-id');
    shopAddsPlugin.api.addProduct(product_id, sku_id);
});
$(document).on('click', '[adds-info]', function() {
    const product_id = this.getAttribute('adds-item-product-id');
    const sku_id = this.getAttribute('adds-item-sku-id');
    const list_id = this.getAttribute('adds-item-list-id');
    (0, $cb75ffeff9590df4$export$2e2bcd8739ae039).show('adds-modal', {
        onShow (modal) {
            const list = shopAddsPlugin.lists[list_id];
            const product = Object.values(list).find((product)=>{
                return product.id === product_id && product.sku_id === sku_id;
            });
            const container = modal.querySelector('[adds-container]');
            let template = `<div class="adds__product--block adds__product--title">${product.name}</div>`;
            if (product.img_url.trim()) template += `<div class="adds__product--block"><img class="adds__product--image" src="${product.img_url}"></div>`;
            if (product.description.trim()) template += `<div class="adds__product--block adds__product--description">${product.description}</div>`;
            template += `<div class="adds__product--block adds__price adds__product--price">${product.price_formatted}</div>`;
            template += `
          <div class="adds__product--block adds__product--purchase">
             <span class="adds__product--close adds__product--purchase--item" adds-modal-close>\u{406}\u{43D}\u{448}\u{43E}\u{433}\u{43E} \u{440}\u{430}\u{437}\u{443}</span>
             <div adds-add-to-cart class="adds__product--button adds__product--purchase--item">\u{414}\u{43E}\u{434}\u{430}\u{442}\u{438} \u{434}\u{43E} \u{43A}\u{43E}\u{448}\u{438}\u{43A}\u{430}</div>
          </div>
        `;
            container.innerHTML = template;
            container.querySelector('[adds-add-to-cart]').addEventListener('click', ()=>{
                shopAddsPlugin.api.addProduct(product_id, sku_id).then(()=>{
                    (0, $cb75ffeff9590df4$export$2e2bcd8739ae039).close('adds-modal');
                });
            });
        },
        closeTrigger: 'adds-modal-close',
        openClass: 'is-open',
        disableScroll: true,
        disableFocus: false,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
    });
});
// Обработчик для кнопки информации (иконка "i")
$(document).on('click', '[adds-info-button]', function() {
    const info_text = shopAddsPlugin.settings.block_info || "\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u0438 \u0440\u043E\u043C\u0430\u043D\u0442\u0438\u0447\u043D\u0456 \u043F\u043E\u0441\u043B\u0443\u0433\u0438 \u0434\u043E \u0432\u0430\u0448\u043E\u0433\u043E \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F.";
    (0, $cb75ffeff9590df4$export$2e2bcd8739ae039).show('adds-modal', {
        onShow (modal) {
            const container = modal.querySelector('[adds-container]');
            let template = `<div class="adds__product--block adds__product--title">\u{406}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{44F}</div>`;
            template += `<div class="adds__product--block adds__product--description">${info_text}</div>`;
            template += `
          <div class="adds__product--block adds__product--purchase">
             <span class="adds__product--close adds__product--purchase--item" adds-modal-close>\u{417}\u{440}\u{43E}\u{437}\u{443}\u{43C}\u{456}\u{43B}\u{43E}</span>
          </div>
        `;
            container.innerHTML = template;
        },
        closeTrigger: 'adds-modal-close',
        openClass: 'is-open',
        disableScroll: true,
        disableFocus: false,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
    });
});
// Обработчик для кнопок +1 в компактном режиме
$(document).on('click', '[adds-add-button]', function() {
    const button = this;
    const product_id = button.getAttribute('adds-item-product-id');
    const sku_id = button.getAttribute('adds-item-sku-id');
    // Добавляем в корзину
    shopAddsPlugin.api.addProduct(product_id, sku_id).then(()=>{
        // Визуальная обратная связь
        button.classList.add('adds__compact--add-button--active');
        setTimeout(()=>{
            button.classList.remove('adds__compact--add-button--active');
        }, 300);
    });
});

})();
//# sourceMappingURL=index.js.map
